// Widget: Page Teasers

import './index.scss';

export default class PageTeasers {
  constructor(root) {
    this.root = root;

    window.app.openDataHref();
  }
}
